import {helpers} from 'gmap-vue'
import Socket from './Socket'
import SocketCommand from './SocketCommand'
import router from '@/router/router'
import {AES, HmacMD5} from '@/lib/crypto/crypto'
import Printer from '@/lib/print/printer.js'
import isDesktopApp from '@/desktop-app/isDesktopApp'
import i18n from '@/lang/lang'
import desktopApp from '@/desktop-app/desktopApp'
import ipcCommandsEnum from '@/desktop-app/ipcCommandsEnum'
import syncBugsnagReporting from '@/desktop-app/bugsnagReporting'
import {MapsProviderEnum} from '@/mixins/maps/mapsCommon'
import * as SocketMenuPosHelper from '@/api/SocketMenuPosHelper'
import * as SocketOrderHelper from '@/api/SocketOrderHelper'
import * as SocketKdsHelper from '@/api/SocketKdsHelper'
import * as SocketTableHelper from '@/api/SocketTableHelper'
import {clone, reloadApp} from '@/lib/helper/helper'
import injectCustomRoutes from '@/router/customRoutes'
import FiscalDocsProviderEnum from '@/api/Enums/FiscalDocsProviderEnum.js'

const {googleMapsApiInitializer} = helpers

export const SocketData = {
  /**
   *
   * @param command {String}}
   * @param data {Object}
   * @param resultCommand {String}
   */
  get: (command, data = {}, resultCommand = '') => {
    resultCommand = resultCommand === '' ? command : resultCommand
    const payload = Object.assign({}, data, {
      command       : command,
      result_command: resultCommand,
      location_id   : window.appConfig ? window.appConfig.LOCATION_DATA.Id : 1
    })

    console.groupCollapsed('%cGET.SocketData:: %c' + command, 'color: #1E88E5', 'color: ' + (command.startsWith('get-') || SocketData.commandExists(SocketCommand, command) ? '#4c4c4c' : '#E53935'))
    console.log(clone(payload))
    console.groupEnd()

    payload.command = SocketCommand.commandToSocketFormat(command)
    payload.result_command = SocketCommand.commandToSocketFormat(resultCommand)
    if (Socket.pusher()) Socket.pusher().channel(Socket.clientChannel()).trigger('client-' + Socket.clientEvent(), payload)
  },

  /**
   *
   * @param command {String}
   * @param responseData {Object}
   * @param requestPayload {Object}
   */
  set: (command, responseData, requestPayload) => {
    const vm = window.Vue
    const desktopBridge = desktopApp()
    const data = responseData ? clone(responseData) : null

    const payload = requestPayload ? clone(requestPayload) : null
    const storageKey = HmacMD5.hash('ROUTE')
    const storedRoute = AES.decrypt(vm.$sessionStorage.get(storageKey))
    command = SocketCommand.commandToClientFormat(command)

    console.groupCollapsed('%cSET.SocketData:: %c' + command, 'color: #388E3C', 'color: #4c4c4c')
    console.log(data)
    console.groupEnd()

    if (vm) vm.$bus.$emit(command, data, payload)

    switch (command) {
    case SocketCommand.Pusher.Pong:
      if (window.isVueRoutesInited) {
        const pingCommands = [
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Location.OnlineOrderingStatus),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Order.Counts),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Message.Counts),
            request_data: {}
          }
        ]

        if (vm.posUserHasComponentPermission('Receipts', 'ACCESS') && vm.appHasFiscalDocsEnabled && vm.appHasFiscalDocsProvider && vm.appFiscalDocsProvider === FiscalDocsProviderEnum.IMPACT) {
          pingCommands.push({
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Receipt.MyDataStatus),
            request_data: {provider: vm.appFiscalDocsProvider || ''}
          })

          if (vm.posUserHasComponentPermission('Tables', 'ACCESS')) {
            pingCommands.push({
              command     : SocketCommand.commandToSocketFormat(SocketCommand.Receipt.DocumentsStatus),
              request_data: {}
            })
          }
        }

        window.callAS(SocketCommand.System.Ping, {commands: pingCommands})
      }
      break

    case SocketCommand.System.Ping:
      Object.keys(data.data).forEach(command => {
        SocketData.set(command, data.data[command])
      })
      break

    case SocketCommand.GetClientId:
      window.socketId = data.socketId || null
      window.callAS(SocketCommand.System.Init, {
        commands: [
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.System.Printers.Get),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.WorkingHours.All),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Staff.Delivery.All),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Staff.Waiter.All),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Order.DailyList),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Order.Counts),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Settings.Misc.Countries),
            request_data: {}
          },
          {
            command     : SocketCommand.commandToSocketFormat(SocketCommand.Customer.CompaniesAll),
            request_data: {}
          }
        ],
        guid    : vm.$DataStore.app.guid,
        ver     : vm.$DataStore.app.versionDesktop,
        verWeb  : vm.$DataStore.app.versionWeb,
        computer: vm.$DataStore.app.computer
      })
      break

    case SocketCommand.HasElectronActive:
      if (Array.isArray(data?.result)) {
        vm.$set(vm.$DataStore.app, 'electronGuidActive', data.result)
      } else {
        vm.$set(vm.$DataStore.app, 'electronGuidActive', [])
      }
      break

    case SocketCommand.System.Init:
      if (!window.isVueRoutesInited) {
        injectCustomRoutes(vm)

        initAppComponents(vm, router)

        initMaps(vm)

        if (vm.posUserHasComponentPermission('DeliveryStaff', 'ACCESS')) window.initBarcodeScanner()
        window.isVueRoutesInited = true
      }

      Object.keys(data.data).forEach(command => {
        SocketData.set(command, data.data[command])
      })

      initData(vm)

      gotoInitRoute(vm, storedRoute)

      initCDS(vm, desktopBridge)
      break

      // CONFIG
    case SocketCommand.System.Config:
      // --------------------------------------------------------------------------
      window.appConfig.LOCATION_DATA = data.LOCATION_DATA
      window.appConfig.ORDER_TYPES = data.ORDER_TYPES
      window.appConfig.PAYMENT_TYPES = data.PAYMENT_TYPES
      window.appConfig.SOURCE_TYPES = data.SOURCE_TYPES
      window.appConfig.EXTRA_CHARGES = data.EXTRA_CHARGES
      window.appConfig.APP_UPDATE = data.APP_UPDATE
      window.appConfig.APP_LOGGING = data.APP_LOGGING
      window.appConfig.POS_VENDORS = data.POS_VENDORS
      window.appConfig.TAX = data.TAX

      vm.$set(vm.AppConfig, 'LOCATION_DATA', data.LOCATION_DATA)
      vm.$set(vm.AppConfig, 'ORDER_TYPES', data.ORDER_TYPES)
      vm.$set(vm.AppConfig, 'PAYMENT_TYPES', data.PAYMENT_TYPES)
      vm.$set(vm.AppConfig, 'SOURCE_TYPES', data.SOURCE_TYPES)
      vm.$set(vm.AppConfig, 'EXTRA_CHARGES', data.EXTRA_CHARGES)
      vm.$set(vm.AppConfig, 'APP_UPDATE', data.APP_UPDATE)
      vm.$set(vm.AppConfig, 'APP_LOGGING', data.APP_LOGGING)
      vm.$set(vm.AppConfig, 'POS_VENDORS', data.POS_VENDORS)
      vm.$set(vm.AppConfig, 'TAX', data.TAX)

      syncBugsnagReporting(data.APP_LOGGING)

      initAppDomainLocked(vm)

      break

      // AJAX
    case SocketCommand.Ajax.Get:
      if (data && data.command) {
        const dataCommands = Array.isArray(data.command) ? data.command : [data.command]
        const excludedCommands = [
          SocketCommand.Payment.EftPos.All,
          SocketCommand.Table.GetById,
          SocketCommand.Order.GetDetails,
          SocketCommand.Catalog.All,
          SocketCommand.Receipt.All,
          SocketCommand.Message.All,
          SocketCommand.Order.Webhook.Get
        ]

        dataCommands.forEach((cmd) => {
          const command = SocketCommand.commandToClientFormat(cmd)

          if (SocketData.commandExists(SocketCommand, command) && !excludedCommands.includes(command)) {
            if (command === window.SocketCommand.Menu.Pos && data?.action) {
              SocketMenuPosHelper.handleSocketPosMenuItemUpdate(command, data)
            } else if (command === window.SocketCommand.Order.DailyGet && data?.action) {
              SocketOrderHelper.handleOrderUpdate(command, data)
            } else if (command === window.SocketCommand.Table.Get && data?.Action) {
              SocketTableHelper.handleTableUpdate(command, data)
            } else if (command === window.SocketCommand.Kds.Order.Get && data?.action) {
              SocketKdsHelper.handleKdsUpdate(command, data)
            } else {
              window.callAS(command, {})
            }
          }
        })
      }
      break

      // ELECTRON
    case SocketCommand.ElectronApp.HardReload:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.HardReload)
      }
      break

    case SocketCommand.ElectronApp.Reload:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.Reload)
      }
      break

    case SocketCommand.ElectronApp.ClearHttpCache:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.ClearHttpCache)
      }
      break

    case SocketCommand.ElectronApp.ClearStorageCache:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.ClearStorageCache)
      }
      break

    case SocketCommand.ElectronApp.ClearAllCache:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.ClearAllCache)
      }
      break

    case SocketCommand.ElectronApp.ClearAllAndRelaunch:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.ClearAllAndRelaunch)
      }
      break

    case SocketCommand.ElectronApp.Relaunch:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.Relaunch)
      }
      break

    case SocketCommand.ElectronApp.RetryLoadMainApp:
      if (isDesktopApp()) {
        desktopBridge.send(ipcCommandsEnum.RetryLoadMainApp)
      }
      break

      // SOCKET
    case SocketCommand.System.Socket.ChannelConnections.Ws:

      if (vm.userIsWaiter && vm.canSeeActiveElectronWorkingStations) window.callClientSocket(SocketCommand.HasElectronActive, {})

      vm.$DataStore.channelConnections = {
        guest: {
          users: [],
          count: 0
        },
        normal: {
          users: [],
          count: 0
        },
        admin: {
          users: [],
          count: 0
        }
      }

      if (data?.normal && data?.guest && data?.admin) {
        const guestUsers = data?.guest?.users || []
        const normalUsers = data?.normal?.users || []
        const adminUsers = data?.admin?.users || []
        const allUsers = [guestUsers, normalUsers, adminUsers]

        for (let u = 0; u < allUsers.length; u++) {
          const users = allUsers[u]
          for (let i = 0; i < users.length; i++) {
            const user = users[i]
            user.alias = ''
            user.hostname = ''
            if (user.electron) {
              const machine = vm.appMachines?.find(machine => machine.guid === user.guid)
              user.alias = machine?.alias || ''
              user.hostname = machine?.hostname || ''
            }
          }
        }

        vm.$DataStore.channelConnections = data
      }
      break

      // COMPANIES
    case SocketCommand.Customer.CompaniesAll:
      vm.$DataStore.companies = data || []
      break

      // COUNTRIES
    case SocketCommand.Settings.Misc.Countries:
      vm.$DataStore.countries = data || []
      break

      // DASHBOARD
    case SocketCommand.Dashboard.Get:
      vm.$set(vm, 'dashboardData', data)
      break

      // TABLES
    case SocketCommand.Table.AllByArea:
      vm.$set(vm.$DataStore, 'tables', data || [])
      break

    case SocketCommand.Table.Get:
      if (data?.table) {
        SocketTableHelper.updateTable(data?.table)
      } else {
        window.callAS(SocketCommand.Table.AllByArea, {})
      }
      break

      // ORDERS
    case SocketCommand.Order.Print:
      if (data.order_id) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printOrderAuto(data.order_id, data.guid, data.source_type_id, data.is_scheduled, data.order_print_id, data.order_print_type, data.order_type_id)
      }
      break

    case SocketCommand.Receipt.Print:
      if (data.receipt_id) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printReceiptAuto(data.receipt_id, data.guid, data.order_print_id, data.order_print_type)
      }
      break

    case SocketCommand.Receipt.PrintManual:
      if (data.receipt_id) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
          Printer.printReceipt(data.receipt_id, data.guid, data.order_print_id, data.order_print_type)
        }
      }
      break

    case SocketCommand.Order.PrintPreparation:
      if (data.order_id && data.group) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printPreparationAuto(data.order_id, data.group, data.guid, data.source_type_id, data.is_scheduled, data.order_print_id, data.order_print_type, data.order_type_id)
      }
      break

    case SocketCommand.Order.MenuPrintMarketing:
      if (data.menu_id && data.template_id) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printMenuMarketingAuto(data.menu_id, data.template_id, data.guid, data.source_type_id, data.is_scheduled)
      }
      break

      // TABLES
    case SocketCommand.Table.SendOrderForPrint:
      if (data.cart_id) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)

          if (data?.waiter) {
            const appMachinePrinters = vm.AppMachinePrinters ? vm.AppMachinePrinters : []
            const appMachineWaiterPrintersActive = appMachinePrinters.filter(printer => printer?.status === '1' && printer?.waiter === '1')
            Printer.printTableOrder(data.cart_id, data?.timestamp || null, appMachineWaiterPrintersActive, 1, false)
          }
        }

        if (!data?.waiter) {
          Printer.printTableOrderAuto(data.cart_id, data?.timestamp || null, data.guid, data.order_print_id, data.order_print_type)
        }
      }
      break

    case SocketCommand.Table.SendOrderPreparationForPrint:
      if (data.cart_id && data.timestamp && data.group) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printTableOrderPreparationAuto(data.cart_id, data.group, data.timestamp, data.guid, data.order_print_id, data.order_print_type)
      }
      break

    case SocketCommand.Table.SendReceiptForPrint:
      if (data.cart_id && data.timestamp) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printTableReceiptAuto(data.cart_id, data.timestamp, data.guid, data.order_print_id, data.order_print_type)
      }
      break

    case SocketCommand.Table.SendCanceledForPrint:
      if (data.cart_id && data.items) {
        if (isDesktopApp()) {
          desktopBridge.send(ipcCommandsEnum.AppFocus)
        }
        Printer.printTableCanceledAuto(data.cart_id, data.items, data.guid, data.order_print_id, data.order_print_type)
      }
      break

    case SocketCommand.Order.Counts:
      vm.$set(vm, 'ordersCounts', data)
      break

    case SocketCommand.Order.DailyList:
      if (data?.items) {
        vm.$set(vm.$DataStore.ordersDataToday, 'count', data?.count || 0)
        vm.$set(vm.$DataStore.ordersDataToday, 'items', data?.items || [])
      } else if (data?.table) {
        vm.$set(vm.$DataStore.ordersDataToday, 'count', data?.table?.items?.count || 0)
        vm.$set(vm.$DataStore.ordersDataToday, 'items', data?.table?.items?.items || [])
      } else {
        vm.$set(vm.$DataStore.ordersDataToday, 'items', data || [])
      }
      break

    case SocketCommand.Kds.Order.Get:
      if (Array.isArray(data) && data?.length && payload?.action) {
        SocketKdsHelper.addOrUpdateKdsOrder(data, payload?.action)
      } else {
        window.callAS(SocketCommand.Kds.All, {})
      }
      break

    case SocketCommand.Order.DailyGet:
      if (data?.order && payload?.action) {
        SocketOrderHelper.addOrUpdateDailyOrder(data?.order, payload?.action)
      } else {
        window.callAS(SocketCommand.Order.DailyList, {})
      }
      if (data?.counts) vm.$set(vm, 'ordersCounts', data?.counts)
      break

    case SocketCommand.Order.ScheduledList:
      if (data?.items) {
        vm.$set(vm.$DataStore.ordersDataScheduled, 'count', data?.count || 0)
        vm.$set(vm.$DataStore.ordersDataScheduled, 'items', data?.items || [])
      } else if (data?.table) {
        vm.$set(vm.$DataStore.ordersDataScheduled, 'count', data?.table?.items?.count || 0)
        vm.$set(vm.$DataStore.ordersDataScheduled, 'items', data?.table?.items?.items || [])
      } else {
        vm.$set(vm.$DataStore.ordersDataScheduled, 'items', data || [])
      }
      break

    case SocketCommand.Order.SavedList:
      if (data?.items) {
        vm.$set(vm.$DataStore.ordersDataSaved, 'count', data?.count || 0)
        vm.$set(vm.$DataStore.ordersDataSaved, 'items', data?.items || [])
      } else if (data?.table) {
        vm.$set(vm.$DataStore.ordersDataSaved, 'count', data?.table?.items?.count || 0)
        vm.$set(vm.$DataStore.ordersDataSaved, 'items', data?.table?.items?.items || [])
      } else {
        vm.$set(vm.$DataStore.ordersDataSaved, 'items', data || [])
      }
      break

      // AADE MyData Status
    case SocketCommand.Receipt.MyDataStatus:
      vm.$set(vm, 'myDataStatus', data?.status ?? false)
      break

      // 8.6 Documents Status
    case SocketCommand.Receipt.DocumentsStatus:
      vm.$set(vm, 'documentsStatus', data?.status ?? false)
      break

      // Online Ordering Status
    case SocketCommand.Location.OnlineOrderingStatus:
      vm.$set(vm, 'onlineOrderingStatus', data?.status ?? false)
      break

      // WORKING HOURS
    case SocketCommand.WorkingHours.All:
      vm.$set(vm, 'orderTypeDefaultTimes', data.settings)
      break

      /* DELIVERY STAFF */
    case SocketCommand.Staff.Delivery.All:
      if (data && Array.isArray(data) && data.length) vm.$set(vm, 'deliveryStaffItems', data || [])
      if (data && data.result && Array.isArray(data.result) && data.result.length) vm.$set(vm, 'deliveryStaffItems', data.result || [])
      break

      /* WAITER STAFF */
    case SocketCommand.Staff.Waiter.All:
      if (data && Array.isArray(data) && data.length) {
        vm.$set(vm, 'waiterStaffItems', data.sort((a, b) => b.HasActiveShift - a.HasActiveShift) || [])
      } else if (data && data.result && Array.isArray(data.result) && data.result.length) {
        vm.$set(vm, 'waiterStaffItems', data.result.sort((a, b) => b.HasActiveShift - a.HasActiveShift) || [])
      } else {
        vm.$set(vm, 'waiterStaffItems', [])
      }

      // eslint-disable-next-line no-case-declarations
      const posUserWaiter = vm.waiterStaffItems.find(waiter => parseInt(waiter.Id) === parseInt(vm.posUser.staff_id))
      if (posUserWaiter) {
        const posUser = vm.posUser
        posUser.Settings = posUserWaiter.Settings
        vm.posUser = posUser
      }
      break

      /* PRINTERS */
    case SocketCommand.System.Printers.Get:
      if (data) {
        const machineGroups = data?.machineGroups || []
        vm.$set(vm, 'AppMachineGroups', machineGroups)

        const groups = data?.groups || []
        vm.$set(vm, 'AppPrinterGroups', groups)

        const templates = data?.templates || []
        vm.$set(vm, 'AppMarketingTemplates', templates)

        const printers = data?.printers?.find(machine => machine.guid === vm.$DataStore.app.guid)
        const machines = data?.printers?.map(machine => {
          return {
            id            : machine?.id || null,
            guid          : machine?.guid || '',
            hostname      : machine?.hostname || '',
            print_required: machine?.print_required || false,
            alias         : machine?.alias || '',
            ver           : machine?.ver || '',
            ver_web       : machine?.ver_web || ''
          }
        })

        vm.$set(vm, 'AppMachines', machines || [])
        vm.$set(vm, 'AppMachinePrinters', printers?.printers_default || [])
        vm.$set(vm, 'AppMachinePreparationPrinters', printers?.printers_preparation || [])
        vm.$set(vm, 'AppMachineFiscalDocPrinters', printers?.printers_receipts || [])
        vm.$set(vm, 'AppMachineFiscalDocTotalsZPrinters', printers?.printers_totals || [])
        vm.$set(vm, 'AppMachineMarketingPrinters', printers?.printers_marketing || [])
      }
      break

      /* Receipts */
    case SocketCommand.Receipt.FiscalDocNotIssued:
      if (vm && data?.Type && data?.UserId && parseInt(data?.UserId) === parseInt(vm?.posUser?.staff_id)) {
        const notificationLang = data?.Table ? 'Common.Misc.Notification.IssueReceipt.Warning.Table' : 'Common.Misc.Notification.IssueReceipt.Warning.Order'
        const fiscalDocType = vm.$t('Common.FiscalDoc')?.find(doc => doc.Code === data.Type)?.Name || ''
        const notificationPayload = {
          receiptType: fiscalDocType,
          amount     : vm.$options.filters.currency(data?.Amount),
          table      : data?.Table || '',
          tableOrder : `#${data?.TableOrderNumber || ''} - ${data?.TableOrderTime || ''}`,
          orderCode  : data?.OrderCode || ''
        }

        vm.$bus.$emit('app-show-notification', {
          title   : vm.$t('Common.Misc.Notification.IssueReceipt.Warning.Title'),
          htmlBody: vm.$t(notificationLang, notificationPayload),
          type    : 'warning',
          icon    : 'warning',
          color   : 'purple',
          timeout : 10000
        })
      }
      break

      /* MENU */
    case SocketCommand.Menu.Pos:
      if (data?.categories && data?.items && !data?.action) SocketMenuPosHelper.setPosMenu(data)
      break

    case window.SocketCommand.Menu.PosItem:
      if (data) SocketMenuPosHelper.updatePosMenuItem(data)
      break

    case SocketCommand.Catalog.TaxesOrphaned:
      if (data?.Orphaned) {
        window.appConfig.TAX.Orphaned = data.Orphaned
        vm.AppConfig.TAX.Orphaned = data.Orphaned
      }
      break
    }
  },

  /**
   *
   * @param commandsObj {Object}
   * @param value {String}
   * @returns {Boolean}
   */
  commandExists: (commandsObj, value) => {
    for (const key in commandsObj) {
      if (commandsObj[key] === value) return true
      if (typeof commandsObj[key] === 'object') {
        const found = SocketData.commandExists(commandsObj[key], value)
        if (found) return true
      }
    }
  },

  /**
   *
   * @param payload {Object}
   * @returns {Boolean}
   */
  apiCallIsAllowed: (payload) => {
    const vm = window.Vue
    const excludedCommands = [SocketCommand.Settings.Misc.Countries]
    const mutedCommands = [SocketCommand.Staff.Delivery.User.Shift, SocketCommand.Staff.Delivery.All, SocketCommand.System.Printers.Get, SocketCommand.Message.Config]
    const validateCommandsEnabled = window?.appConfig?.LOCATION_DATA?.HasValidateCommands || false
    const commands = vm?.posUser?.Commands || []
    const commandAllowed = !validateCommandsEnabled || commands.includes(payload.command) || excludedCommands.map(permission => SocketCommand.commandToSocketFormat(permission)).includes(payload.command)
    const commandMuted = mutedCommands.map(permission => SocketCommand.commandToSocketFormat(permission)).includes(payload.command)

    if (commandAllowed) return true

    if (!commandAllowed && !commandMuted) {
      console.groupCollapsed('%cAPI::COMMAND.NOT-ALLOWED:: %c' + SocketCommand.commandToClientFormat(payload.command), 'font-weight: bold; color: #b22828', 'color: #4c4c4c')
      console.log(clone(payload))
      console.groupEnd()

      // Dispatch Error Event to Stop any Loaders
      setTimeout(() => {
        vm.$bus.$emit(SocketCommand.commandToClientFormat(payload.result_command), {
          error  : true,
          status : 0,
          message: '',
          payload: payload
        }, payload)
      })

      // Bugsnag.notify(new Error('API::COMMAND.NOT-ALLOWED:: ' + SocketCommand.commandToClientFormat(payload.command)))
    }

    return false
  }
}


const initAppComponents = (vm, router) => {
  let component = null
  for (let r = 0; r < window.appConfig.routerItems.length; r++) {
    component = window.appConfig.routerItems[r].component
    window.appConfig.routerItems[r].component = window.routerComponents[component]

    if (window.appConfig.routerItems[r].children) {
      for (let c = 0; c < window.appConfig.routerItems[r].children.length; c++) {
        component = window.appConfig.routerItems[r].children[c].component
        window.appConfig.routerItems[r].children[c].component = window.routerComponents[component]
      }
    }

    router.addRoute(window.appConfig.routerItems[r])
  }
}

const initMaps = (vm) => {
  const providers = window.AppConfig?.LOCATION_DATA?.Maps?.Pos || {}
  const providersArray = Object.values(providers)
  const googleProvider = providersArray?.find(provider => provider.Name === MapsProviderEnum.Google && provider.Key)
  const defaultMapsProvider = window.appConfig?.LOCATION_DATA?.Maps?.Pos?.DefaultMapsProvider
  const googleMapsKey = googleProvider?.Key || defaultMapsProvider?.Key

  googleMapsApiInitializer({
    key      : googleMapsKey,
    libraries: 'places,geometry,visualization',
    language : i18n.locale || import.meta.env.VITE_I18N_LOCALE
    // v        : 3.38
  }, false)
}

const initData = (vm) => {
  vm.$bus.$emit(SocketCommand.Pusher.IsOnline, {status: true})

  setTimeout(() => {
    window.callAS(SocketCommand.Location.OnlineOrderingStatus, {})

    if (vm.posUserHasComponentPermission('Receipts', 'ACCESS') && vm.appHasFiscalDocsEnabled && vm.appHasFiscalDocsProvider && vm.appFiscalDocsProvider === FiscalDocsProviderEnum.IMPACT) {
      window.callAS(SocketCommand.Receipt.MyDataStatus, {provider: vm.appFiscalDocsProvider || ''})

      if (vm.posUserHasComponentPermission('Tables', 'ACCESS')) {
        window.callAS(SocketCommand.Receipt.DocumentsStatus, {})
      }
    }
  }, 1000)

  if (vm.posUserHasComponentPermission('POS', 'ACCESS')) window.callAS(SocketCommand.Menu.Pos, {})
  if (vm.posUserHasComponentPermission('Tables', 'ACCESS')) window.callAS(SocketCommand.Table.AllByArea, {})
  if (vm.posUserHasComponentPermission('Dashboard', 'ACCESS')) window.callAS(window.SocketCommand.Dashboard.Get, {stats_range: 'week'})
  if (vm.posUserHasComponentPermission('MessagesInbox', 'ACCESS')) window.callAS(SocketCommand.Message.Counts, {})
  if (vm.posUserHasComponentPermission('SupportCenter', 'ACCESS')) vm.$DataStore.support.tickets.fetch()

  window.callClientSocket(SocketCommand.System.Socket.ChannelConnections.Ws, {})
}

const gotoInitRoute = (vm, storedRoute) => {
  initAppDomainLocked(vm)

  if (storedRoute && vm.posUserHasComponentPermission(storedRoute.name, 'ACCESS')) {
    vm.$router.replace(storedRoute)
  } else {
    if (vm.userIsDelivery) {
      vm.$router.replace({name: 'DeliveryUserDashboard'})
    } else if (vm.userIsKds) {
      vm.$router.replace({name: 'Kds'})
    } else if (vm.userIsWaiter) {
      const waiter = vm.waiterStaffItems?.find(staff => staff.Id.toString() === vm.posUser.staff_id.toString())
      if (waiter?.HasActiveShift && vm.posUserHasComponentPermission('Tables', 'ACCESS')) {
        vm.$router.replace({name: 'Tables'})
      } else if (vm.posUserHasComponentPermission('WaiterStaff', 'ACCESS')) {
        vm.$router.replace({name: 'WaiterStaff'})
      } else {
        if (window.appConfig.routerItems.length > 0) {
          vm.$router.replace({name: window.appConfig.routerItems[0].name})
        } else {
          throw new Error('No available routes')
        }
      }
    } else {
      if (vm.posUser?.ShowSettingsWizard && vm.posUserHasComponentPermission('Dashboard', 'ACCESS')) {
        vm.$router.replace({name: 'Dashboard'})
      } else {
        if (vm.posUserHasComponentPermission('Orders', 'ACCESS')) {
          vm.$router.replace({name: 'OrdersToday'})
        } else if (vm.posUserHasComponentPermission('Dashboard', 'ACCESS')) {
          vm.$router.replace({name: 'Dashboard'})
        } else if (vm.posUserHasComponentPermission('Tables', 'ACCESS')) {
          vm.$router.replace({name: 'Tables'})
        } else {
          if (window.appConfig.routerItems.length > 0) {
            vm.$router.replace({name: window.appConfig.routerItems[0].name})
          } else {
            throw new Error('No available routes')
          }
        }
      }
    }
  }
}

const initCDS = (vm, desktopBridge) => {
  if (vm.posUserHasComponentPermission('Pos', 'ACCESS') && isDesktopApp()) {
    const cdsDisplays = window?.appConfig?.CDS_DISPLAYS || []
    const display = cdsDisplays.find(cdsDisplay => cdsDisplay.guid === vm.$DataStore.app.guid)

    let cdsUrl = `${import.meta.env.VITE_POS_URL}cds?lang=${vm.$i18n?.locale || 'el'}`

    if (!!parseInt(display?.custom_url_active) && !!display?.custom_url) {
      cdsUrl = display.custom_url
    }

    if (display && !!parseInt(display.auto_open)) {
      desktopBridge.send(ipcCommandsEnum.OpenCds, {
        ...display,
        cds_url: cdsUrl
      })
    }
  }
}

const initAppDomainLocked = (vm) => {
  if (vm.appDomainIsLocked) {
    vm.$router.replace({name: 'DomainLocked'})
    return
  }

  if (!vm.appDomainIsLocked && vm.$route.name === 'DomainLocked') {
    reloadApp()
  }
}

export default SocketData
